import React from 'react';
import { Box, CircularProgress } from '@material-ui/core';

import { ModalStep } from 'components/Flow/components/ModalStep';
import { DeedHeartHands } from 'components/Flow/components/DeedHeartHands';

export const Loading = (): JSX.Element => (
  <ModalStep
    showProgressBar
    header={<DeedHeartHands />}
    headerStyles={{
      paddingTop: 16,
    }}
  >
    <Box mb={4} justifyContent="center" display="flex">
      <CircularProgress />
    </Box>
  </ModalStep>
);
